import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const receivingSourceAvailabilitySchema = z.enum([
  "ready",
  "schema_unavailable",
]);

export const inboundReceivingBinRowSchema = z.object({
  binLabel: z.string(),
  closureLabel: z.string(),
  progressLabel: z.string(),
  pendingLabel: z.string(),
  processedLabel: z.string(),
});
export type InboundReceivingBinRow = z.infer<
  typeof inboundReceivingBinRowSchema
>;

export const inboundReceivingRowSchema = z.object({
  shipmentReference: z.string(),
  merchantName: z.string(),
  arrivalLabel: z.string(),
  processingOpen: z.boolean(),
  processingLabel: z.string(),
  binsClosedLabel: z.string(),
  pendingLabel: z.string(),
  pendingSort: z.number().int().nullable(),
  processedLabel: z.string(),
  processedSort: z.number().int().nonnegative(),
  bins: z.array(inboundReceivingBinRowSchema),
});
export type InboundReceivingRow = z.infer<typeof inboundReceivingRowSchema>;

export const listEligibleReceivingSourceBins = {
  name: "listEligibleReceivingSourceBins" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({
    availability: receivingSourceAvailabilitySchema,
    rows: z.array(inboundReceivingRowSchema),
  }),
};
